import React from "react";

const toPct = (value) => {
  const n = parseFloat(value);
  if (isNaN(n)) return 0;
  const pct = n > 1 ? n : n * 100;
  return Math.max(0, Math.min(100, pct));
};

const Bar = ({ label, value, color }) => {
  const pct = toPct(value);
  return (
    <div className="mb-2">
      <div className="d-flex justify-content-between small mb-1">
        <span className="fw-bold text-uppercase">{label}</span>
        <span className="fw-bold">{pct.toFixed(2)}%</span>
      </div>
      <div
        style={{
          height: 14,
          width: "100%",
          backgroundColor: "#e9ecef",
          borderRadius: 7,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div
          style={{
            width: `${pct}%`,
            height: "100%",
            backgroundColor: color,
            transition: "width 0.3s ease",
          }}
        />
      </div>
    </div>
  );
};

// contrato / pagado: share of the contracts' total (avance financiero),
// shown below real when the report has them.
const ReporteAvanceBars = ({ programado, real, financiero }) => {
  const totales = financiero?.totales;
  const conFinanciero = totales && totales.total_contrato > 0;
  return (
    <div className="mb-md-0 mb-4">
      <h5 className="bold mb-3 text-uppercase">Avance de Obra</h5>
      <Bar label="Programado" value={programado} color="#007991" />
      <Bar label="Real" value={real} color="#89d405" />
      {conFinanciero && (
        <>
          <Bar
            label="Contrato"
            value={(totales.devengado / totales.total_contrato) * 100}
            color="var(--primary)"
          />
          <Bar
            label="Pagado"
            value={(totales.pagado / totales.total_contrato) * 100}
            color="#FF8008"
          />
        </>
      )}
    </div>
  );
};

export default ReporteAvanceBars;
